import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AppWithRouterAccess from "./AppWithRouterAccess";
import "./App.css";

const theme = createTheme({
  typography: {
    fontSize: 10, // Adjust the default font size
  },
  components: {
    // Customize the component sizes
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: 12, // Adjust the button font size
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontSize: 12, // Adjust the text field font size
          height: 30, // Adjust the text field height
          size: "small", // Adjust the text field height
          boxSizing: "inherit", // Adjust the text field height
        },
      },
    },
    // Add other components here with their desired customizations
  },
});

function App() {
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    // TODO: Implement authorizations

    setShowLoading(true);
    setTimeout(() => {
      setShowLoading(false);
      // zoomOut(); // Apply zoom out after hiding the loading state
    }, 1);
  }, []);

  return (
    // <ThemeProvider theme={theme}>
    <>
      {showLoading ? (
        <div className="App">spinner</div>
      ) : (
        <Router>
          <AppWithRouterAccess setShowLoading={setShowLoading} />
        </Router>
      )}
  </>
    // </ThemeProvider>
  );
}

export default App;
